import { Icon, MenuAction } from "@inductiveautomation/ws-components";
import { TFunction } from "i18next";

import {
  downloadActions,
  purchaseTestAction,
  submitTestAction,
  visitInductiveUniversityAction,
} from "./Training.actions";
import { Certification, CertificationActionCallback } from "./Training.types";

export const getCurrentActions = (
  t: TFunction,
  onAction: CertificationActionCallback,
  certification: Certification,
  canPurchaseOnline = false
) => {
  switch (certification.type) {
    case "CORE":
      return coreActions(t, onAction, certification, canPurchaseOnline);
    case "GOLD":
      return goldActions(t, onAction, certification, canPurchaseOnline);
    default:
      return credentialActions(t, onAction);
  }
};

const credentialActions = (
  t: TFunction,
  onAction: CertificationActionCallback
) => {
  const visitIU = () => onAction("visit-inductive-university");

  return [[visitInductiveUniversityAction(t, visitIU)]];
};

// TS-1841 Drawer Core actions
const coreActions = (
  t: TFunction,
  onAction: CertificationActionCallback,
  certification: Certification,
  canPurchaseOnline = false
) => {
  if (certification.status === "IN_PROGRESS") {
    return certification.earnMethod === "TEST"
      ? [
          [
            {
              id: "open-test",
              label: t("training.actions.open_test.label"),
              onClick: () =>
                onAction("open-test", { certificationId: certification.type }),
              iconLeft: "test-outlined" as const,
              iconRight: "open-small" as const,
              iconRightVariant: "neutralLight" as const,
              icon: <Icon name="open" />,
            },
          ],
        ]
      : [];
  }

  if (canPurchaseOnline) {
    return [[purchaseTestAction(t, onAction, certification.type)]];
  }

  return [];
};

const goldActions = (
  t: TFunction,
  onAction: CertificationActionCallback,
  certification: Certification,
  canPurchaseOnline = false
) => {
  const { status } = certification;

  if (status === "IN_PROGRESS") {
    return certification.earnMethod === "TEST"
      ? [[submitTestAction(t, () => onAction("submit-test"))]]
      : [];
  }

  if (status === "IN_PROGRESS_WITH_TRAINING") {
    return [
      [
        {
          id: "view-course-details",
          label: t("training.actions.view_course_details"),
          onClick: () => onAction("view-course-details"),
          iconLeft: "school-outlined" as const,
          iconRight: "open-small" as const,
          iconRightVariant: "neutralLight" as const,
          icon: <Icon name="info" />,
        },
      ],
    ];
  }

  if (status === "IN_PROGRESS_FAILED_PENDING_RETRY") {
    return [[submitTestAction(t, () => onAction("submit-test"), true)]];
  }

  if (canPurchaseOnline) {
    return [[purchaseTestAction(t, onAction, certification.type)]];
  }

  return [];
};

export const getHistoryActions = (
  t: TFunction,
  onAction: CertificationActionCallback,
  {
    tsAccountCertificateDownloadFe,
    tsAccountTrainingBadgeDownloadFe,
  }: {
    tsAccountCertificateDownloadFe: boolean;
    tsAccountTrainingBadgeDownloadFe: boolean;
  }
) => {
  const actions = downloadActions(t, onAction);
  const downloadCertification = actions.find(
    ({ id }) => id === "download-certificate"
  ) as MenuAction;
  const downloadBadge = actions.find(
    ({ id }) => id === "download-badge"
  ) as MenuAction;
  const applicableActions: MenuAction[] = [];
  if (tsAccountTrainingBadgeDownloadFe) {
    applicableActions.push(downloadBadge);
  }
  if (tsAccountCertificateDownloadFe) {
    applicableActions.push(downloadCertification);
  }
  return [applicableActions];
};
